import { mapGetters, mapActions } from 'vuex';
import _get from 'lodash/get';
import _find from 'lodash/find';

import CactusStrings from './CactusStringsMixin';

export default {
  mixins: [CactusStrings],
  data() {
    return {
      rulesVisibility: []
    };
  },
  computed: {
    ...mapGetters(['latestAppData', 'getRule']),

    ruleProvider() {
      return this.cmpConfig.rule_provider || [];
    },

    ruleSubscriber() {
      return this.cmpConfig.rule_subscriber || [];
    },

    firstInstanceParamName() {
      return this.cmpConfig.instance_param_name[0];
    },

    appParam() {
      return (this.cmpConfig.instanceParams || {}).param;
    },

    currentDataFromFwApp() {
      let fwApp = this.getFwApp();
      let value = this.getAppValue(fwApp.app, fwApp.param);

      if (value === undefined) {
        return this.handleFallbackPolicy(this.cmpConfig.policy);
      }

      return value;
    },

    defaultWhenActivated() {
      let value = this.cmpConfig.value.default.restrictions.fallback_to_default_when_activated;
      if (value && value.length) {
        return Number(value[0]);
      } else {
        return undefined;
      }
    },

    isVisible() {
      if (this.cmpConfig.rule_subscriber) {
        return this.visibilityWithRules;
      } else {
        return true;
      }
    },

    visibilityWithRules: {
      get() {
        return this.rulesVisibility.map(rule => this.getRule(rule)).every(el => el === true);
      },
      set(newVal) {
        this.rulesVisibility = newVal;
      }
    },

    transformations() {
      return this.cmpConfig.value.default.transformations || [];
    },

    defaultValue() {
      return this.cmpConfig.value.default.default;
    },

    valueFromFw() {
      return this.getAppValue(this.fwParams.app, this.fwParams.param);
    },

    /**
     * Dynamic Check for number of decimal points - 2020/10/01
     * Remove switch case for dynamic number of decimal points
     */
    cmpDecimals() {
      const num = ((((this.cmpConfig || {}).value || {}).default || {}).restrictions || {}).step;
      const NumberOfDecimalPoints = num.split('.')[1] ? num.split('.')[1].length : 0;

      return NumberOfDecimalPoints;
    }
  },
  methods: {
    ...mapActions(['setRuleProvider', 'setExpertViewParams']),

    applyRules() {
      if (this.ruleSubscriber) {
        this.ruleSubscriber.forEach(ruleSet => {
          if (ruleSet.target === 'value') {
            this.valuesWithRules = ruleSet.rule.map(rule => {
              return rule;
            });
          }

          if (ruleSet.target === 'visibility') {
            this.visibilityWithRules = ruleSet.rule.map(rule => {
              return rule;
            });
          }
        });
      }
    },

    getAppValue(appName, paramName) {
      try {
        return _get(this.latestAppData, `${appName}.parameters.${paramName}`, undefined);
      } catch {
        return undefined;
      }
    },

    getDataObj(val) {
      let valKey = 'default';
      if (this.cmpConfig.rule_subscriber && this.valuesWithRules) {
        valKey = this.cmpConfig.rule_subscriber[0].rule[0] || 'default';
      }
      return _find(this.cmpConfig.value, [`${valKey}.values.value`, val]);
    },

    getFwApp() {
      return _find(this.fwParams, this.firstInstanceParamName, {})[
        `${this.firstInstanceParamName}`
      ];
    },

    handleFallbackPolicy(policy) {
      switch (policy) {
        case 'policy_default':
          return this.cmpConfig.value.default.default;
        case 'policy_hidden':
          this.isVisible = false;
          return;
        default:
          break;
      }
    },

    applyRuleProvider(defaultValue, dropdownSelectPosition) {
      if (this.cmpConfig.rule_provider) {
        this.cmpConfig.rule_provider.forEach(rule => {
          if (rule.broadcast) {
            this.setRuleProvider({ name: rule.rule, value: defaultValue });
          } else if (!rule.enabled.values && rule.enabled.position) {
            // check if defaultValue has a match, otherwise use the selectPosition
            if (!_find(this.cmpConfig.value.default.values, ['value', defaultValue])) {
              // use fallback_position
              const fallbackPosition = this.cmpConfig.value.default.fallback_position;
              this.setRuleProvider({ name: rule.rule, value: !!fallbackPosition });
            } else {
              this.setRuleProvider({ name: rule.rule, value: !!dropdownSelectPosition });
            }
          } else if (rule.enabled.values.includes(defaultValue.toString())) {
            this.setRuleProvider({ name: rule.rule, value: true });
          } else {
            this.setRuleProvider({ name: rule.rule, value: false });
          }
        });
      }
    },

    applyTransformations(val) {
      if (this.transformations.length >= 1) {
        this.transformations.forEach(transform => {
          val = this.applyTransformOperation(val, transform.value, transform.operation);
        });
      }
      return val;
    },

    applyTransformOperation(value, opValue, operation) {
      switch (operation) {
        case 'division':
          return parseFloat(value) / parseFloat(opValue);
        case 'multiplication':
          return parseFloat(value) * parseFloat(opValue);
        case 'reciprocal':
          return 1 / parseFloat(value);
        default:
          return parseFloat(value);
      }
    },

    applyReverseTransformations(val) {
      if (this.transformations.length >= 1) {
        this.transformations.forEach(transform => {
          val = this.applyReverseTransformOperation(val, transform.value, transform.operation);
        });
      }

      return val;
    },

    applyReverseTransformOperation(value, opValue, operation) {
      switch (operation) {
        case 'division':
          return parseFloat(value) * parseFloat(opValue);
        case 'multiplication':
          return parseFloat(value) / parseFloat(opValue);
        case 'reciprocal':
          return 1 / parseFloat(value);
        default:
          return parseFloat(value);
      }
    }
  }
};
